import { BrowserRouter } from 'react-router-dom';
import { I18nProvider } from '@/context/I18nProvider';
import { ToastProvider } from '@/context/ToastProvider';
import { ToastViewport } from '@/components/ui/Toast';
import { SesionProvider } from '@/features/inversionistas/identidad/SesionProvider';
import { AppRoutes } from '@/router/routes';
import { ScrollToTop } from '@/router/ScrollToTop';

/**
 * `I18nProvider` envuelve a todo lo demás: los avisos del `ToastViewport`
 * también se traducen. El idioma es una preferencia del dispositivo.
 *
 * ~~Aquí había además un `AuthProvider`, que se fue con el backend el
 * 2026-09-18.~~ **Vuelve a haber sesión desde el 2026-09-20**, y es otra cosa:
 * `SesionProvider` sólo sostiene la del área de inversionistas, y hoy contra un
 * adaptador local que no autentica nada. Va **dentro** de `I18nProvider` porque
 * los mensajes de error del acceso se traducen, y **fuera** del router porque la
 * sesión no depende de la ruta: quien recarga `/inversionistas/panel` tiene que
 * rehidratar antes de que el guardia decida.
 */
export function App() {
  return (
    <I18nProvider>
      <ToastProvider>
        <SesionProvider>
          {/*
            Se habilitan las banderas de react-router v7 desde ahora: el
            comportamiento nuevo ya es el correcto y hace la migración a v7 un
            cambio de versión, no una cacería de regresiones.
          */}
          <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <ScrollToTop />
            <AppRoutes />
          </BrowserRouter>
        </SesionProvider>
        <ToastViewport />
      </ToastProvider>
    </I18nProvider>
  );
}
